import { GraphBuilder } from '../graph/builder';
import { ComponentDef } from './types';

export const weightInitComponent: ComponentDef = {
  id: 'weight-init',
  name: 'Weight Initialization',
  description: 'Compare Xavier, He, and Normal weight initialization scaling strategies.',
  category: 'function',
  params: [
    { name: 'd_model', label: 'Model dimension', type: 'number', default: 512, min: 64, max: 4096, step: 64 },
    { name: 'seq_len', label: 'Sequence length', type: 'number', default: 128, min: 1, max: 8192, step: 1 },
    { name: 'variant', label: 'Variant', type: 'select', default: 'all', options: [{ label: 'All (comparison)', value: 'all' }, { label: 'Xavier/Glorot', value: 'xavier' }, { label: 'Kaiming/He', value: 'he' }, { label: 'Small Init', value: 'small' }, { label: 'Truncated Normal', value: 'truncated' }] }
  ],
  buildGraph: (params) => {
    const d_model = Number(params.d_model);
    const seq_len = Number(params.seq_len);
    const variant = params.variant;

    const g = new GraphBuilder();
    g.input('w', [seq_len, d_model]);

    if (variant === 'all') {
      g.scale('xavier', 'w', 'Xavier');
      g.scale('he', 'w', 'He');
      g.scale('small', 'w', 'Small');
      g.scale('truncated', 'w', 'Truncated');
      g.concat('out_cat', ['xavier', 'he', 'small', 'truncated'], [seq_len, d_model * 4]);
      g.output('out', 'out_cat');
    } else if (variant === 'xavier') {
      g.scale('xavier', 'w', 'sqrt(2/(fan_in+fan_out))');
      g.output('out', 'xavier');
    } else if (variant === 'he') {
      g.scale('he', 'w', 'sqrt(2/fan_in)');
      g.output('out', 'he');
    } else if (variant === 'small') {
      g.scale('small', 'w', '× 0.02');
      g.output('out', 'small');
    } else {
      g.scale('truncated', 'w', 'truncnorm(σ=0.02)');
      g.output('out', 'truncated');
    }

    return g.build();
  }
};
